import { ChildInfoSubmitter } from '../../lib/child-info/child-info-submit.service'

export class DocsChildInfoSubmitter implements ChildInfoSubmitter {
  public submit(): void {
    alert('Navigate to child-contact-info')
  }
  public validateAndSubmit(): void {
    this.submit()
  }
}
